//
//
//
//
//
//
//

import Overview from './_components/Overview';
import Message from './_components/Message';
import ApplyRecord from './_components/ApplyRecord';
import CollectionRecord from './_components/CollectionRecord';
import BrowseHistory from './_components/BrowseHistory';
import Profile from './_components/Profile';

export default {
  name: 'Personal',
  middleware: 'auth',
  data() {
    return {
      menu: {
        overview: { label: '個人總覽', component: Overview },
        message: {
          label: '我的通知',
          component: Message,
          hide: !process.env.isMessageOpen,
        },
        applyRecord: { label: '應徵紀錄', component: ApplyRecord },
        recordsManagement: {
          label: '記錄管理',
          children: {
            collectionRecord: {
              label: '我的收藏',
              component: CollectionRecord,
            },
            // recommendRecord: { label: '推薦紀錄', component: RecommendRecord },
            // withdrawal: { label: '提領紀錄', component: Withdrawal },
            browseHistory: { label: '瀏覽紀錄', component: BrowseHistory },
          },
        },
        profile: { label: '我的檔案', component: Profile },
        // logout: { label: '登出', component: Logout },
      },
    };
  },
  head() {
    return {
      title: 'STEP1NE 個人職業發展 - 探索職業機會與專業指導',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'STEP1NE 個人職業發展 - 您的職業成長夥伴',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '透過STEP1NE發掘您的職業潛力，瀏覽各行業的工作機會，並獲得量身定制的職業發展和求職指導。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '透過STEP1NE發掘您的職業潛力，瀏覽各行業的工作機會，並獲得量身定制的職業發展和求職指導。',
        },
      ],
    };
  },
};
